import { useGlobalSearchStore } from "data/store/global-search/GlobalSearch";
import React, { createContext, useContext, useState, ReactNode } from "react";
import { SortingOrder } from "utils/sort";

export type GlobalSearchContextType = {
  isOpen: boolean;
  search: string;
  sortByCreatedDate: SortingOrder;
  handleOpen: () => void;
  handleClose: () => void;
  setSearch: (search: string) => void;
  handleSortByCreatedDate: () => void;
};

const GlobalSearchContext = createContext<GlobalSearchContextType | undefined>(
  undefined,
);

type GlobalSearchProviderProps = {
  children: ReactNode;
};

export const GlobalSearchProvider = ({
  children,
}: GlobalSearchProviderProps) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [search, setSearch] = useGlobalSearchStore((state) => [
    state.searchTerm,
    state.updatedSearchTerm,
  ]);
  const [sortByCreatedDate, setSortByCreatedDate] =
    useState<SortingOrder>("desc");

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSortByCreatedDate = () => {
    setSortByCreatedDate((prevState) => (prevState === "asc" ? "desc" : "asc"));
  };

  const value = {
    isOpen,
    search,
    sortByCreatedDate,
    setSearch,
    handleOpen,
    handleClose,
    handleSortByCreatedDate,
  };

  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  );
};

export const useGlobalSearchContext = (): GlobalSearchContextType => {
  const context = useContext(GlobalSearchContext);
  if (context === undefined) {
    throw new Error(
      "useGlobalSearch must be used within a GlobalSearchProvider",
    );
  }
  return context;
};
